import { BASE_CLASS_PREFIX } from '../base/constants';
const cssClasses = {
  PREFIX: `${BASE_CLASS_PREFIX}`
};
const strings = {
  LAYOUT: ['vertical', 'horizontal']
};
export { cssClasses, strings };